import type { Vector3Tuple } from "three";

export type AnimationName =
  | "Idle_A"
  | "Idle_B"
  | "Idle_C"
  | "Walk"
  | "Run"
  | "Clicked"
  | "Bounce"
  | "Attack"
  | "Death"
  | "Eat"
  | "Fear"
  | "Fly"
  | "Hit"
  | "Jump"
  | "Roll"
  | "Sit"
  | "Spin"
  | "Swim";

export type AgentStatus = "idle" | "moving";

export interface AgentState {
  id: string;
  name: string;
  position: Vector3Tuple;
  rotation: number;
  currentAnimation: AnimationName;
  targetPosition: Vector3Tuple | null;
  path: Vector3Tuple[];
  pathIndex: number;
  status: AgentStatus;
  speed: number;
}

export type PropId =
  | "computer"
  | "telephone"
  | "fileCabinet"
  | "calendar"
  | "mailbox"
  | "notebook";

export interface PropDefinition {
  id: PropId;
  label: string;
  clickMessage: string;
  position: Vector3Tuple;
}

export interface EngineConfig {
  cameraDefaultDistance: number;
  cameraMinDistance: number;
  cameraMaxDistance: number;
  cameraDefaultPolar: number;
  cameraDefaultAzimuth: number;
  agentWalkSpeed: number;
  agentRunSpeedThreshold: number;
  idleCycleIntervalMs: number;
  worldSize: number;
}

export const DEFAULT_ENGINE_CONFIG: EngineConfig = {
  cameraDefaultDistance: 18,
  cameraMinDistance: 5,
  cameraMaxDistance: 25,
  cameraDefaultPolar: Math.PI / 3.5,
  cameraDefaultAzimuth: (Math.PI / Math.PI) * -0.01,
  agentWalkSpeed: 2,
  agentRunSpeedThreshold: 3,
  idleCycleIntervalMs: 5000,
  worldSize: 8,
};
